import { RootState } from '@next/core-lib/app';
export interface ProductionState extends RootState {
  cowList: CowListItem[];
  productionSummary: ProductionSummary;
}

export interface ProductionSummary {
  groups: Group[];
  cows: Cow[];
}

export interface Group {
  name: string;
  age: number;
  dayProduction: DayProduction;
  production305Days: Production305Days;
  bsk: Bsk;
  attentions: AttentionSummary;
}
export interface Cow {
  internationalCowId: string;
  age: number;
  parity: number;
  dayProduction: DayProduction;
  production305Days: Production305Days;
}

export interface DayProduction {
  lactationDays: number;
  kgMilk: number;
  fatPercentage: number;
  proteinPercentage: number;
  lactosePercentage: number;
  kgFatProtein: number;
  ureum: number;
  cows?: string[];
}

export interface Production305Days {
  isk?: number;
  netProduction: number;
  kgMilk: number;
  fatPercentage: number;
  proteinPercentage: number;
  kgFat: number;
  kgProtein: number;
  lactation: number;
  cows?: string[];
}

export interface Bsk {
  value: number;
  numberOfAnimals: number;
}

export interface ProductionSummaryReport {
  [key: string]: string | number;
  groupName?: string;
  dayNumberOfAnimals?: number;
  daylactationDays?: number;
  dayKgMilk?: number;
  dayFatPercentage?: number;
  dayProteinPercentage?: number;
  dayLactosePercentage?: number;
  dayKgFatProtein?: number;
  dayUreum?: number;
  days305Age?: number;
  days305NumberOfAnimals?: number;
  days305KgMilk?: number;
  days305FatPercentage?: number;
  days305ProteinPercentage?: number;
  days305KgFat?: number;
  days305KgProtein?: number;
  days305NetProduction?: number;
  days305lactation?: number;
  bskNumberOfAnimals?: number;
  bskValue?: number;
}

export interface CowListItem {
  internationalCowId: string;
  number: number;
  name: string;
  parity: number;
  lactationDays: number;
  kgMilkExpected: number;
  kgMilk: number;
  fatPercentage: number;
  proteinPercentage: number;
  isk: number;
  lactation: number;
  attentions: Attention;
}

export enum Attention {
  none = 'None',
  decreasePercentageKgMilk = 'DecreasePercentageKgMilk',
  minimumFatpercentage = 'MinimumFatpercentage',
  minimumProteinPercentage = 'MinimumProteinPercentage',
  maximumFatProteinPercentage = 'MaximumFatProteinPercentage',
  fatPercentageLowerThenProteinPercentage = 'FatPercentageLowerThenProteinPercentage',
}

export interface AttentionSummary {
  cows: string[];
  numberOfAnimals: number;
  decreasePercentageKgMilkCount: number;
  decreasePercentageKgMilkPercentage: number;
  minimumProteinPercentageCount: number;
  minimumProteinPercentagePercentage: number;
  ketoseCount: number;
  ketosePercentage: number;
  maximumFatProteinPercentageCount: number;
  maximumFatProteinPercentagePercentage: number;
  fatPercentageLowerThenProteinPercentageCount: number;
  fatPercentageLowerThenProteinPercentagePercentage: number;
}
